import LText from "@components/LText";

import LBox from "@components/LBox";
import LArtwork from "@components/LArtwork";
import { Access } from "@hooks/trpc/useAccesses";
import { AccessDetailsDismiss } from "../../types";

const Collaborators = ({
  collaborators,
  lineup,
  artist = false,
}: {
  collaborators: Access["collaborators"];
  lineup?: Access["lineup"];
  /** Kept for call-site compatibility; acts are not links, as on Link in Bio. */
  dismiss?: AccessDetailsDismiss;
  /** A merch product's: "Artist", the whole line-up, headliner first, as
   *  Link in Bio's merch page lists it. */
  artist?: boolean;
}) => {
  const rows =
    lineup?.filter((row) => artist || row.position !== 1) ??
    collaborators.map((artist, index) => ({
      type: "artist" as const,
      id: artist.id,
      position: index + 2,
      artistId: artist.id,
      name: artist.name,
      imageUrl: artist.image,
    }));
  if (!rows.length) return null;
  return (
    <LBox gap="s2_5">
      <LText variant="Body/B1/Medium" color="white">
        {artist ? "Artist" : lineup ? "Line-up" : "Hosted by"}
      </LText>
      <LBox gap="s2">
        {rows.map((c) => (
          <LBox
            key={c.id}
            flexDirection="row"
            gap="s3"
            alignItems="center"
            borderRadius="m-l"
            bg="whiteTranslucent10"
            p="s2"
          >
            <LArtwork
              url={c.imageUrl}
              imageSize="small"
              size={36}
              borderRadius="max"
            />
            <LBox flex={1} gap="s1">
              <LText variant="Body/B1/Medium" color="white" numberOfLines={1}>
                {c.name}
              </LText>
            </LBox>
          </LBox>
        ))}
      </LBox>
    </LBox>
  );
};

export default Collaborators;
